import {
    UI_INITIALIZE,
    FB_VALIDATION_STORAGE,
    VALIDATION_REQUEST_AUTH,
    VALIDATION_REQUEST_AUTH_FAIL,
    VALIDATION_REQUEST_AUTH_SUCCESS,
    CCR_VALIDATION_REQUEST_AUTH,
    CCR_VALIDATION_REQUEST_AUTH_FAIL,
    CCR_VALIDATION_REQUEST_AUTH_SUCCESS,
    PIN_DISCOVERY_FAILURE
} from '-/actions/types';

const INITIAL_STATE = {
    validated: null,
    ccrValidated: null
};

export default (state = INITIAL_STATE, action) => {
    const {type, value, payload} = action;

    switch (type) {
        case UI_INITIALIZE:
            return {
                ...state,
                ...value.validationInfo
            };
        case PIN_DISCOVERY_FAILURE:
            return {
                ...state,
                pinDiscoveryFailure: true,
                submittedPin: payload ? payload.submittedPin : null
            };
        case FB_VALIDATION_STORAGE:
            return {
                ...state,
                fbValidationInfo: payload
            };
        case VALIDATION_REQUEST_AUTH:
            return {
                ...state,
                validated: null
            };
        case VALIDATION_REQUEST_AUTH_FAIL:
            return {
                ...state,
                validated: false
            };
        case VALIDATION_REQUEST_AUTH_SUCCESS:
            return {
                ...state,
                validated: true
            };
        case CCR_VALIDATION_REQUEST_AUTH:
            return {
                ...state,
                ccrValidated: null
            };
        case CCR_VALIDATION_REQUEST_AUTH_FAIL:
            return {
                ...state,
                ccrValidated: false
            };
        case CCR_VALIDATION_REQUEST_AUTH_SUCCESS:
            return {
                ...state,
                ccrValidated: true
            };
    }

    return state;
};
